import Icon from '../components/Icon.vue'

Icon.register({"coins":{"width":512,"height":512,"paths":[{"d":"M0 405.3V448C0 483.3 86 512 192 512S384 483.3 384 448V405.3C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128C426 128 512 99.3 512 64S426 0 320 0 128 28.7 128 64 214 128 320 128zM0 300.4V352C0 387.3 86 416 192 416S384 387.3 384 352V300.4C342.7 334.4 267.1 352 192 352S41.3 334.4 0 300.4zM416 311.4C473.3 300.3 512 279.7 512 256V213.3C488.8 229.7 454.7 240.9 416 247.8V311.4zM192 160C86 160 0 195.8 0 240S86 320 192 320 384 284.2 384 240 298 160 192 160zM411.3 216.3C471.3 205.5 512 184.3 512 160V117.3C476.5 142.4 415.5 155.9 351.3 159.1 380.8 173.4 402.5 192.6 411.3 216.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/coins.js
// module id = null
// module chunks = 